"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = _default;

var _react = _interopRequireDefault(require("react"));

function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      border: '2px solid white'
    }
  }, "Question View", props.children);
}